"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _validate = require("@/utils/validate");
var _nprogress = require("nprogress");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AuditForm',
  data: function data() {
    return {
      dialogVisible: false,
      orderNos: [],
      // 需审核的订单编号
      auditForm: {
        reviewStatus: null,
        // 审核状态
        remarks: '' // 备注说明
      },
      auditRules: {
        reviewStatus: [{
          required: true,
          message: '请选择审核状态',
          trigger: ['change', 'blur']
        }],
        remarks: [{
          required: true,
          message: '请输入备注说明',
          trigger: 'blur'
        }]
      },
      loading: false // 加载状态
    };
  },
  methods: {
    // 显示审核表单
    open: function open(orderNos) {
      this.orderNos = orderNos;
      this.dialogVisible = true;
      this.resetForm();
    },
    // 关闭表单
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.resetForm();
    },
    // 重置表单
    resetForm: function resetForm() {
      var _this = this;
      this.auditForm = {
        reviewStatus: null,
        remarks: ''
      };
      this.$nextTick(function () {
        _this.$refs.auditForm && _this.$refs.auditForm.clearValidate();
      });
    },
    // 提交审核
    submitAudit: (0, _validate.Debounce)(function () {
      var _this2 = this;
      this.$refs.auditForm.validate(function (valid) {
        if (!valid) return;
        _this2.loading = true;
        var params = _objectSpread({
          orderNos: _this2.orderNos
        }, _this2.auditForm);
        (0, _order.handleRiskOrderReviewApi)(params).then(function (res) {
          _this2.$message.success('操作成功');
          setTimeout(function () {
            _this2.dialogVisible = false;
            _this2.$emit('success');
          }, 1000);
        }).catch(function (error) {
          console.log('审核失败: ', error);
        }).finally(function () {
          _this2.loading = false;
        });
      });
    })
  }
};